export default class ThunkCancelledError extends Error {
  constructor(message?: string) {
    super(message ?? 'Thunk was cancelled')
  }
}
